import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/* ── Capture install prompt (works in both dev and prod) ──────────────── */
window.__pwaInstallPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  window.dispatchEvent(new CustomEvent('pwaInstallAvailable'));
});

window.addEventListener('appinstalled', () => {
  window.__pwaInstallPrompt = null;
  window.dispatchEvent(new CustomEvent('pwaInstalled'));
});

/* ── Register Service Worker — PRODUCTION ONLY ────────────────────────────
   In development (npm start), the dev-server does not reliably serve sw.js,
   which causes "Failed to update a ServiceWorker" errors.
   We skip registration entirely during development.
────────────────────────────────────────────────────────────────────────── */
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[PWA] Service worker registered:', reg.scope);

        // Listen for controller change (new SW activated) → reload
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload();
        });

        // Detect new version waiting
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[PWA] New version available.');
            }
          });
        });

        // Check for updates every 60 s
        setInterval(() => reg.update(), 60_000);
      })
      .catch((err) => console.warn('[PWA] SW registration failed:', err));
  });
} else if (process.env.NODE_ENV === 'development') {
  // In development, unregister any leftover service workers to avoid stale caches
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => {
        reg.unregister();
        console.log('[PWA] Dev mode — unregistered leftover SW:', reg.scope);
      });
    });
  }
}
